import React, { useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * ForgotPasswordModal
 *
 * Props:
 *  - isOpen (boolean): Modal visibility toggle
 *  - onClose (function): Called to close the modal
 *  - onSend (function): Called with email when the user submits the form
 */
const ForgotPasswordModal = ({ isOpen, onClose, onSend }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSend(email);
      setEmail("");
      onClose();
    } catch {
      // hata onSend içinde toast ile gösterildi, modal açık kalır
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-md shadow-lg w-full max-w-md p-6 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-black text-xl font-bold"
        >
          &times;
        </button>

        {/* Title */}
        <h2 className="text-xl font-semibold mb-4">{t("resetPasswordTitle")}</h2>

        {/* Email form */}
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder={t("enterYourEmail")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
            className="w-full px-4 py-2 border border-gray-300 rounded-md mb-4 focus:outline-none focus:ring-2 focus:ring-[#1B5E20] disabled:opacity-60"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-button-bg text-white py-2 rounded-full hover:bg-[#164a17] transition-colors disabled:opacity-60"
          >
            {loading ? t("sending") || "Sending..." : t("send")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
